
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'FaqLayout'
})
export default class FaqLayout extends Vue {}
